import styled from 'styled-components';

import { responsive } from '@/utils';

import { controlsFadeTransition } from '../../cameraStreamControls.tokens.ts';

export const RadialControlsHost = styled.div<{ $zIndex: number; $visible: boolean }>`
  position: absolute;
  inset: auto auto 0 0;
  z-index: ${({ $zIndex }) => $zIndex};
  display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
  pointer-events: none;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity ${controlsFadeTransition};
`;
export const RadialControlsPad = styled.div<{ $visible: boolean }>`
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  padding: ${responsive.spacing.large};
`;
